import tw from "#src/utils/tw.ts";
import { useSearchParams } from "#src/utils/useSearchParams.ts";

interface Props {
  offering: {
    tags: {
      id: string;
      title: string;
      order: number;
    }[];
  };
  className?: string;
  tagClassName?: string;
}

interface TagProps {
  tagClassName?: string;
  children: React.ReactNode;
}

export function OfferingTag(props: TagProps) {
  return (
    <div
      className={tw(
        "mb-1 mr-1 inline-block rounded-sm bg-borderGray px-2 py-1.5 text-2xs font-bold uppercase leading-none text-empty sm:mb-px",
        props.tagClassName
      )}
    >
      {props.children}
    </div>
  );
}

export default function OfferingTags(props: Props) {
  const params = useSearchParams();

  if (!props.offering?.tags || props.offering?.tags.length === 0) {
    return null;
  }

  return (
    <>
      {[...(props.offering?.tags || [])]
        .sort((a, b) => a.order - b.order)
        .map((t) => {
          return (
            <OfferingTag
              tagClassName={tw(
                params.getAll("tag").includes(t.id) && "bg-paleMain",
                props.tagClassName
              )}
              key={t.id}
            >
              {t.title}
            </OfferingTag>
          );
        })}
    </>
  );
}
